import React from 'react'

import authMap from 'assets/images/MaskGroup1.png'
import logo from 'assets/logo/logo_blue.png'
const Index = () => {
    return (
        <div className="gx-leftAuthSide">
            <div className="gx-position-relative">
                <div className="main-overlay"></div>
                <img src={authMap} alt="authMap"  className="main-image"/>
                <img src={logo} alt="" className="logo-image"/>
            </div>
        </div>
    )
}

export default Index
